import { render, staticRenderFns } from "./ProviderBillingCard.vue?vue&type=template&id=45bc003e&scoped=true&"
import script from "./ProviderBillingCard.vue?vue&type=script&lang=js&"
export * from "./ProviderBillingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bc003e",
  null
  
)

export default component.exports